import { z } from 'zod';
import { ToolVisibilitySchema } from './skills.js';
export const PromptVersionSourceSchema = z.enum([
    'manual',
    'lesson_incorporation',
    'rollback',
    'data_audit',
    'create',
]);
/**
 * Skill 변경 이력 — 이름과 달리 systemPrompt 외에도 그 시점의 name / description /
 * pairsWellWith / toolVisibility / tools / enabled 까지 한 row 의 snapshot 으로 함께 보존.
 * 옛 row 는 systemPrompt 외 필드가 NULL.
 */
export const SkillPromptVersionSchema = z.object({
    id: z.string().uuid(),
    skillId: z.string().uuid(),
    version: z.number().int().positive(),
    systemPrompt: z.string(),
    /** 그 시점의 name. 옛 row 는 null. */
    name: z.string().nullable(),
    /** 그 시점의 description. 옛 row 는 null. */
    description: z.string().nullable(),
    /** 그 시점의 pairsWellWith. 옛 row 는 null. */
    pairsWellWith: z.array(z.string()).nullable(),
    /** 그 시점의 toolVisibility. 옛 row 는 null. */
    toolVisibility: ToolVisibilitySchema.nullable(),
    /** 그 시점의 tools (skill_tools 스냅샷). 옛 row 는 null. */
    tools: z
        .array(z.object({ toolKey: z.string(), config: z.record(z.string(), z.unknown()) }))
        .nullable(),
    /** 그 시점의 enabled. 옛 row 는 null. */
    enabled: z.boolean().nullable(),
    /** admin 이 입력한 변경 메모. system-generated row 는 null. */
    changelog: z.string().nullable(),
    source: PromptVersionSourceSchema,
    incorporatedLessonIds: z.array(z.string().uuid()),
    createdBy: z.string().uuid().nullable(),
    createdByName: z.string().nullable(),
    createdAt: z.string(),
});
export const SkillPromptVersionListSchema = z.object({
    versions: z.array(SkillPromptVersionSchema),
});
export const IncorporateLessonsRequestSchema = z.object({
    /** 흡수 대상 lesson 들. 1~20개. 모두 active 여야 한다. */
    lessonIds: z.array(z.string().uuid()).min(1).max(20),
});
export const IncorporateLessonsProposalSchema = z.object({
    currentPrompt: z.string(),
    proposedPrompt: z.string(),
    lessonIds: z.array(z.string().uuid()),
    model: z.string(),
});
export const IncorporateLessonsCommitRequestSchema = z.object({
    proposedPrompt: z.string().min(1).max(10000),
    lessonIds: z.array(z.string().uuid()).min(1).max(20),
});
//# sourceMappingURL=skill-prompt-versions.js.map